<template>
    <div :class="headerCss()">
        <div class="row">
            <div class="col-lg-6 leftarea">
                <slot/>
            </div> 
            <div class="col-lg-6 rightarea">
                <slot name="headerright" />
                <div v-show="autoSearch" class="input-group me-4">
                    <span class="input-group-text" @click.prevent="loadgrid"><fa-icon icon="search" /></span>
                    <input type="text" class="search-field form-control" placeholder="Search" :readonly="loading" v-model="search" @keydown.enter.prevent="loadgrid">
                </div>
                <button v-show="reloadButton" class="btn btn-info" :disabled="loading" @click.prevent="loadgrid" >
                    <fa-icon icon="sync-alt" />
                </button>
            </div> 
        </div>
    </div>    
</template>

<style scoped lang="scss">
    .leftarea, .rightarea {
        display:flex;
        align-items: center;
    }
    .leftarea {
        margin-bottom: .2rem;
        margin-top: .2rem;
    }
    .rightarea {
        justify-content: flex-end
    }
    .input-group {
        width:auto;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: { type: String, required: false, default: "" },
        reloadButton: { type: Boolean, required: false, default: true },
        cssHeader: { type: String, required: false, default: "" },
        autoSearch: { type: Boolean, required: false, default: false },
        autoSearchTimer: { type: Number, required: false, default: 0 },
        loading: { type: Boolean, required: false, default: false },
    },
    emits: ["loadgrid"],
    data() {
        return {
            searchTimeout: 0,
            search: "",
        };
    },
    mounted() {
        this.search = this.modelValue;
    },
    methods: {
        headerCss(): string  {
            return `card-header ${this.cssHeader}`;
        },
        loadgrid(): void {
            this.clearSearchTimeout();
            this.$emit("loadgrid", this.search);
        },
        clearSearchTimeout(): void {
            if (this.searchTimeout) 
                clearTimeout(this.searchTimeout);
            this.searchTimeout = 0;
        },
    },
    watch: {
        search(val: string): void {
            this.search = val;
            if (this.autoSearch && this.autoSearchTimer) {
                this.clearSearchTimeout();
                this.searchTimeout = setTimeout((): void => {
                    this.loadgrid();
                }, this.autoSearchTimer) as unknown as number;
            }
        },
    },
});

</script>
